module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-permanents5.1b35336d.png";